<div class="d-inline-flex justify-content-start align-items-center c-vehicle-header__status"
     *ngIf="vehicle?.telemetry && vehicle?.ride">
  <app-vehicle-status [lastPosition]="vehicle?.telemetry"
                      [rideTelemetry]="vehicle?.ride"></app-vehicle-status>
  <app-vehicle-location [vehicle]="vehicle" [ellipsis]="true" position="right"></app-vehicle-location>

</div>
